import React, { Component } from 'react';

const PrepContracts = () => {
	return ( <h1>Prepare Contracts</h1> );
}
 
export default PrepContracts;